import { StatusVm } from '../../Models/StatusVm';

const isInputMatch = (statusObj: any, input: any) => {
    try {
        return statusObj.KEY == input || input.includes(statusObj.EN) || input.includes(statusObj.DK)
    }
    catch {
        return false;
    }
}

export const GetStatusName = (input: any) => {
    let data = require('../../assets/CardStatus.json')
    let status = data.find((el: any) => isInputMatch(el, input))
    return status.DK + " (" + status.EN + ")";
}

export const GetDanishStatusName = (id: string) => {
    let data = require('../../assets/CardStatus.json')
    return data.find((el: any) => el.KEY == id).DK
}

export const GetEnglishStatusName = (id: string) => {
    let data = require('../../assets/CardStatus.json')
    return data.find((el: any) => el.KEY == id).EN
}

export const GetStatusVm = (input: any) => {
    if (!input) return new StatusVm()
    let data = require('../../assets/CardStatus.json')
    let status = data.find((el: any) => isInputMatch(el, input))
    var s: StatusVm = {
        Id: status.KEY,
        NameDK: status.DK,
        NameEN: status.EN,
    }
    return s
}

export const GetStatusId = (data : any, name : string) => {
    for (let i = 0; i < data.length; i++) {
      if (name.includes(data[i].DK) || name.includes(data[i].EN) ) {
        return data[i].KEY
      }
    }

    return -1;
  }

